export function exportCSV({
    header, rows, filename = "export.csv"
}: {
    header: string[];
    rows: (string | number | null | undefined)[][];
    filename?: string;
}) {
    if (!rows.length) return;

    const csvHeader = header.join(",")

    const csvRows = rows.map(row =>
        row.map(item => {
            if (item === null) return "";
            return `"${String(item).replace(/"/g, '""')}"`;
        }).join(",")
    ).join("\n")

    const csvString = `${csvHeader}\n${csvRows}`;

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
}